import React from 'react';
import Accordian from '../../../shared/components/accordian/normal-accordian';
import { ReactComponent as ArrowSvg } from '../../../assets/images/arrow/icon_arrow_down.svg';

const Faq = ({ content, title, pageContent }) => {
    const faqSection = content.faq_section.map((obj) => {
        return {
            title: obj.accordion_title,
            content: obj.accordion_content
        };
    });
    return (
        <div className='faq-pg'>

            {/* inner-banner section start */ }
            <div className="innerBaneer no-image">
                <div className="container">
                    <div className="row-wrap">
                        <div className="box-12 content-box">
                            {/* <div className="customAnim slide-top is-animate"> */ }
                            <div className="inner-box">
                                <div className="intro-box p-18 center-align text-center">
                                    {
                                        title &&
                                        <h1 className="heading has-line">{ title }</h1>
                                    }
                                    <div dangerouslySetInnerHTML={ { __html: pageContent } }></div>
                                </div>
                            </div>
                            {/* </div> */ }
                        </div>
                    </div>
                </div>
            </div>
            {/* inner-banner section end */ }

            {/* according list section start */ }
            <div className="information-box faq-accordion">
                <div className="container">
                    <Accordian
                        duration={ 1500 }
                        className="accordion-list"
                        summaryClassName="accordion-heading"
                        detailClassName="accordion-body"
                        expandIcon={ <ArrowSvg /> }
                        options={
                            faqSection

                        }
                    />
                </div>
            </div>

            {/* according list section end*/ }

            {/* contact section start */ }
            <div className="information-box with-button text-center find-position">
                <div className="container">
                    <div className="intro-box p-18">
                        {
                            content && content.contact_section_title &&
                            <h2 className="h1 heading has-line">{ content.contact_section_title }</h2>
                        }
                        {
                            content && content.contact_section_info &&
                            <p>{ content.contact_section_info }</p>
                        }

                    </div>
                </div>
            </div>
            {/* contact section end*/ }

            {/* social section start */ }
            <div className="socialboxs">
                <div className="container">
                    <div className="row-wrap">
                        {
                            content && !!content.contact_section.length && content.contact_section.map((obj, index) => {
                                return (
                                    <div className="box-12 box-md-auto item-box" key={ index }>
                                        <div className="inner-box">
                                            <div className="img-box">
                                                {
                                                    obj.image &&
                                                    <figure>
                                                        <img src={ obj.image.url } alt="ime-contact" />
                                                    </figure>
                                                }
                                            </div>
                                            <div className="info-box" dangerouslySetInnerHTML={ { __html: obj.content } }>

                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }

                    </div>
                </div>
            </div>
            {/* social section end */ }

        </div>
    );
};

export default Faq;